<div [class]="this.smallScreen ? 'verticalDisplay' : 'horizontalDisplay'">


 <div><img mat-card-image src="/assets/NotFound.svg" alt="Not found page"  /></div>
 <div [class]="this.smallScreen ? 'text-align-center' : 'text-align-left' ">
  <h1 translate>COMMONS.NOT_AVAILABLE_PAGE_2</h1>
  <h6>{{ this.notAvailablePage }}</h6>
</div>

</div>
